

export class Model_CRM_TeleCall_FollowUp {

    public FollowUpId: number;
    public Tele_Call_Id: number;
    public FolloWUpText: string;
    public FollowUpdate: string;
    public FollowUpTime: string;
}